import cn from 'classnames';
import React, { memo, useMemo } from 'react';

import { ArrowNewIcon, DoubleArrowIcon } from '@src/components/icons';

import styles from './styles.module.scss';

const ARROW_STYLES = {
  double: {
    '--width': '16px',
    '--height': '16px',
    '--fill': 'currentColor',
    '--stroke': 'none',
  },
  single: {
    '--width': '10px',
    '--height': '10px',
    '--fill': 'none',
    '--stroke': 'currentColor',
  },
};

interface IProps {
  className?: string;
  text?: string;
  arrowPosition?: 'left' | 'right';
  arrowType?: 'single' | 'double';
  direction?: 'up' | 'down';
  onClick?: () => void;
}

export const ArrowButton: React.FunctionComponent<IProps> = memo((props: IProps) => {
  const { className, arrowPosition = 'right', arrowType = 'double', text = 'назад', direction = 'up', onClick } = props;

  const ArrowComponent = arrowType === 'double' ? DoubleArrowIcon : ArrowNewIcon;
  const isLeftPosition = arrowPosition === 'left';

  const transform = arrowPosition === 'left' ? 'rotate(90deg)' : undefined;

  const arrowStyles = useMemo(
    () =>
      (({
        ...ARROW_STYLES[arrowType],
        '--transform': direction === 'down' ? 'rotate(180deg)' : transform,
        '--margin': text ? '5px' : undefined,
      } as unknown) as React.CSSProperties),
    [arrowType, direction, text, transform],
  );

  const arrow = <ArrowComponent className={styles.arrow_icon} style={arrowStyles} />;

  return (
    <div className={cn(styles.wrapper, className)} onClick={onClick}>
      {isLeftPosition ? arrow : null}

      {text}
      {isLeftPosition ? null : arrow}
    </div>
  );
});
